import React from 'react';
import {useSelector} from "react-redux";
import {useTfaPassed} from "../hooks/user";
import {RootState} from "../store/reducers/reducers";
import ExternalQuotationsRequestSignIn from "../components/external_quotation/request_sign_in";
import ExternalQuotationListing from "../components/external_quotation/listing";
import Loading from "../components/loading";

export default function ExternalQuotationsPage() {
  const profileFetched = useSelector((state: RootState) => state.user.profileFetched);
  const tfaPassed = useTfaPassed();

  if (tfaPassed) {
    if (profileFetched) {
      return <ExternalQuotationListing />;
    } else {
      return <Loading />;
    }
  } else {
    return <ExternalQuotationsRequestSignIn />;
  }
}